export const localesMap: {[key: string]: string} = {
  'pl': 'pl-PL',
  'en': 'en-US',
}
